import {format} from 'date-fns';
import {Typography} from '@/components/ui/typography';

interface DateGroupHeaderProps {
  date: Date | null;
}

/** Date section header for event lists grouped by day. */
export function DateGroupHeader({date}: DateGroupHeaderProps) {
  return (
    <Typography level="S2" className="sticky top-0 z-10 mb-3 bg-muted py-2 text-slate-500 lg:-top-4 lg:-mx-4 lg:px-4">
      {date ? (
        <>
          {format(date, 'EEEE')}
          <span className="mx-1.5 text-slate-300">|</span>
          {format(date, 'MMMM d, yyyy')}
        </>
      ) : (
        'No date'
      )}
    </Typography>
  );
}
